<template>
  <div class="project-detail">
    <div class="main-box">
      <el-form ref="form" :model="editForm" label-width="100px" size="mini" label-position="left" :rules="addFormRules">
        <!-- <div class="project-name"><i class="iconfont eltte-doc"></i>上海第一中学数学教师培训项目</div> -->
        <base-info :baseForm="editForm" :disabled="project.state!=0"></base-info>
        <el-tabs v-model="activeName" type="card" @tab-click="clickTab">
          <el-tab-pane label="立项信息" name="create">
            <detail-info :detailForm="editForm" :disabled="!commitFlag" v-if="clickList.includes('create')"></detail-info>
          </el-tab-pane>
          <el-tab-pane label="实施方案上传" name="plan" :disabled="!activeList.includes('plan')">
            <plan-upload :disabled="!commitFlag" ref='plan' v-if="clickList.includes('plan')"></plan-upload>
          </el-tab-pane>
          <el-tab-pane label="项目预算" name="budget" :disabled='!activeList.includes("budget")'>
            <budget :project="project" ref="budget" :detail="detail" :disabled="!commitFlag" v-if="clickList.includes('budget')"></budget>
          </el-tab-pane>
          <el-tab-pane label="项目实施" name="execute" :disabled='!activeList.includes("execute")'>
            <execute ref="execute" :detail="detail" :disabled="!commitFlag" v-if="clickList.includes('execute')"></execute>
          </el-tab-pane>
          <el-tab-pane label="项目结项" name="end" :disabled='!activeList.includes("end")'>
            <end-project ref="end" :detail="detail" :disabled="!commitFlag" v-if="clickList.includes('end')"></end-project>
          </el-tab-pane>
        </el-tabs>
        <div class="body">
          <div class="commit-box" v-if="commitFlag">
            <el-button class="save-btn" @click="save('save')">保存</el-button>
            <el-button class="transfer-btn" @click="transfer()">转办</el-button>
            <el-button class="commit-btn" @click="commit()">提交</el-button>
          </div>
          <div class="commit-box" v-if="cancelFlag">
            <el-button class="save-btn" @click="cancel()">撤销</el-button>
          </div>
          <approve-info v-if="approveFlag" @approve='approve'></approve-info>
          <!-- <search-box @getResult="getSearchResult" ref='searchBox' title="审批人搜索"></search-box> -->
          <select-user @getResult="getSearchResult" @close='selectShow = false' :field="field" :title="title" :show='selectShow' ref="selectUser"></select-user>
        </div>
      </el-form>
      <el-card class="box-card proc-box" v-if="procTaskList.length">
        <div slot="header" class="clearfix">
          <span>流程状态</span>
        </div>
        <div class="proc-list">
          <div class="proc-item" v-for="(item,index) in procTaskList" :key="index">
            <div class="proc-name">{{item.procNodeName}}</div>
            <div class="proc-info">
              <el-tag :type="getTagType(item.handleType)" size="small">{{approveStateMap[item.handleType]}}</el-tag>
              <span class="time-info">{{item.handleTime|dateFormat('YYYY/MM/DD HH:mm')}}</span>
              <span class="handler">当前操作人：{{item.handleUserName}}</span>
              <span class="handler">下一处理人：{{item.nextUserName}}</span>
              <span class="opinion" v-if="item.handleOpinion">{{'审批意见：'+item.handleOpinion}}</span>
            </div>
          </div>

        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import commonData from '../../common/commonData'
import * as projectApi from '../../api/projectAPI'
import * as procNodesApi from '../../api/procNodesAPI'
import detailInfo from '../subcomponents/project_detail_info.vue'
import baseInfo from '../subcomponents/project_base_info.vue'
import approveInfo from '../subcomponents/approve_info.vue'
import planUpload from '../subcomponents/plan_upload.vue'
import budget from '../subcomponents/budget.vue'
import selectUser from '../subcomponents/select_user.vue'
import execute from '../subcomponents/execute.vue'
import endProject from '../subcomponents/end_project.vue'
export default {
  name: 'projectDetail',
  data() {
    return {
      editForm: {
        inst: {},
        task: {}
      },
      clickList: [],//点击tab列表 点击之后才加载对应的子组件
      disabled: true,
      userInfo: {},
      activeName: 'create',//当前激活的tab页
      activeList: ['create'],//可点击的tab页集合
      model: 'edit',
      project: {},
      detail: {},//项目详情
      approver: {},//处理人信息
      procInst: {},//当前流程实例
      procTaskList: [],//流程列表
      projectProcName: '',//当前项目流程名称
      selectShow: false,
      projectId: '',
      procNodeId: '',//流程节点ID
      approveStateMap: {},//审批状态枚举
      lastNodeId: '',//下一个应该处理的节点
      procNodes: [],//项目流程的所有节点
      proCommitMap: { 'create': 1, 'plan': 2, 'budget': 3, 'execute': 4, 'end': 5 },//项目提交对应项目状态,
      field: '',
      timer: '',
      title: ''


    }
  },
  async created() {
    this.addFormRules = commonData.projectFormRules
    this.userInfo = await this.$store.getters.getUserInfo
    console.log(this.$route);
    let id = this.$route.params.id
    let res = await procNodesApi.findAll()
    if (res.flag) {
      this.procNodes = res.data
    }
    this.approveStateMap = commonData.approveStatusMap
    //this.model = this.$route.query.model
    if (id) {
      this.projectId = id
      let param = { id }
      await this.qryProject(param)
    }
    
      this.timer = setInterval(async ()=>{ await this.autoSave()}, 30000);
    
  },
  methods: {
    async qryProject(param) {
      let res = await projectApi.qryProject(param)
      if (res.flag) {
        this.editForm = { ...res.data.detail, ...res.data.project }
        let pattern = 'YYYY-MM-DD HH:mm:ss'
        this.project = res.data.project
        this.detail = res.data.detail
        this.procTaskList = res.data.procTaskList || []
        this.editForm.trainDate = [moment(this.detail.trainStartTime).format(pattern), moment(this.detail.trainEndTime).format(pattern)]
        this.editForm.summaryDate = [moment(this.detail.summaryStartTime).format(pattern), moment(this.detail.summaryEndTime).format(pattern)]
        this.editForm.surveyDate = [moment(this.detail.surveyStartTime).format(pattern), moment(this.detail.surveyEndTime).format(pattern)]
        if (this.procTaskList.length) {
          this.procInst = res.data.procInst
          let task = this.procTaskList[this.procTaskList.length - 1]
          this.procNodeId = task.procNodeId
          /*  1项目下一个节点属那个角色操作
           2填写项目信息、上传方案、预算、执行 ---创建人操作 不展示审批区域 详情能编辑 显示提交区域
           3立项审核、方案审核、预算审核、项目结项 ---审批人操作 不展示提交区域 详情不能编辑 显示审核区域
           项目下一个节点怎么确定
           1判断当前节点属于哪个角色操作 
           2当前节点操作人是创建人，正常来说下一个节点就是当前节点+1
           3当前节点操作人是审批人，审批通过下一个节点等于当前节点+1，审批不通过下一个节点就是当前节点-1
           */
          let currNode = this.procNodes.find(p => p.id == task.procNodeId)
          let handler = currNode.handler
          let obj = { 2: 'create', 3: 'create', 4: 'plan', 5: 'plan', 6: 'budget', 7: 'budget', 8: 'execute', 9: 'execute', 10: 'end', 11: 'end' }
          this.lastNodeId = this.procNodeId
          if (handler == 'creater') {
            if(task.handleType==1){
              this.lastNodeId = this.procNodeId + 1
            }
          } else if (handler == 'approver') {
            if (task.handleType == 2 || task.handleType == 4) {
              this.lastNodeId = this.procNodeId + 1
            } else if (task.handleType == 3) {
              this.lastNodeId = this.procNodeId - 1
            }
          }
          // if (this.lastNodeId >11) {
          //   this.lastNodeId = 11
          // }
          /*tab页流程能够点击的逻辑
          下一个节点id大于当前节点ID 
            if 下一个节点操作人是提交人
              if 当前用户是提交人 所有节点加上下一个节点 按组获取tab页
              else 当前用户是审批人 所有节点不变 按组获取tab页
            else 下一个节点操作人是审批人 所有节点不变 按组获取tab页
          下一个节点ID小于当前节点 只存在下一个节点操作人为提交人（审批不通过情况）
            if 当前用户是提交人所有节点不变 按组获取tab页
            else 当前用户是审批人 所有节点减去最后1个节点 按组获取tab页
          */
          let nodeIds = this.procTaskList.map(p => p.procNodeId)
          if (this.lastNodeId > this.procNodeId) {
            let nextNode = this.procNodes.find(p => p.id == this.lastNodeId)
            if (nextNode.handler == 'creater') {
              if (this.userInfo.id == task.nextUserId || ['root', 'admin'].includes(this.userInfo.code)) {
                nodeIds = [...nodeIds, this.lastNodeId]
              }
            }
          } else {
            if (this.procInst.currApproveId == this.userInfo.id) {
              nodeIds = nodeIds.slice(0, nodeIds.length - 1)
            }
          }
          console.log("nodeIds", nodeIds);
          nodeIds = nodeIds.map(i => obj[i]).filter(n => n != undefined)
          this.activeList = Array.from(new Set(nodeIds))
          this.activeName = this.activeList[this.activeList.length - 1]
        }
        this.projectProcName = this.activeName
        this.clickList.push(this.activeName)
        console.log("task", this.project.empId, this.userInfo.id);
      }
    },

    async save(type) {//项目状态、提交类型
      let map = {}
      if (this.activeName == 'create') {
        map = await this.createSaveOrCommit(type)
      } else if (this.activeName == 'plan') {
        map = await this.planSaveOrCommit(type)
      } else if (this.activeName == 'budget') {
        map = await this.budgetSaveOrCommit(type)
      } else if (this.activeName == 'execute') {
        map = await this.executeSaveOrCommit(type)
      } else if (this.activeName == 'end') {
        map = await this.endSaveOrCommit(type)
      }
      map.type = type
      map.projectId = this.projectId
      console.log('map', map);
      // return
      let msg = type == 'save' ? '保存' : '提交'
      this.$confirm('确认' + msg + '该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log("getSearchResult", this.proCommitMap, this.activeName, this.proCommitMap[this.activeName]);
        let res = await projectApi.update(map)
        if (res.flag) {
          this.$message.success(res.data)
          await this.qryProject({ id: this.projectId })
        }
      })
    },
    async validate() {
      let flag = true
      await this.$refs.form.validate(async (valid, rules) => {
        if (!valid) {
          for (const key in rules) {
            flag = false;
            console.log(key, rules[key][0].message)
            this.$message.error(rules[key][0].message)
            throw Error(rules[key][0].message)
          }
          return
        }
      })
      if (!flag) {
        throw Error('校验失败')
      }
    },
    async autoSave() {//自动保存
    if(!this.commitFlag) return
    let map = {}
      if (this.activeName == 'create') {
        map =await this.createSaveOrCommit('save')
      } else if (this.activeName == 'budget') {
        map =await this.budgetSaveOrCommit('save')
        //projectApi.update(map)
      }
      if(Object.keys(map).length){
        map.cancelLoading = true
        console.log("autoSave",map);
        // this.$refs.budget.qryFeeList()
        let res = await projectApi.update(map)
        if (res.flag) {
         // this.$message.success(res.data)
         if(this.activeName == 'create'){

           await this.qryProject({ id: this.projectId ,cancelLoading: true})
         }else if(this.activeName == 'budget'){
          //  this.$refs.budget.qryFeeList()
         }
        }
      }
    },
    async approve(type, data) {//审批
      console.log("approve", type, data)
      if (type == 3 && !data) {
        this.$message.error("审批意见不能为空！")
        return
      }
      let stateMap = { '32': 11, '52': 12, '72': 13, '33': 21, '53': 22, '73': 23, '92': 14, '93': 24, '113': 25, '112': 6 }
      let procNodeId = this.procNodeId + 1
      let project = { id: this.project.id, state: stateMap[procNodeId + "" + type] }
      let procNodeName = this.procNodes.find(n => n.id == procNodeId).nodeName
      let nextUserId = type == 2 ? this.userInfo.id : this.procInst.userId
      let nextUserName = type == 2 ? this.userInfo.username : this.procInst.username
      let handleUserId = this.userInfo.id
      let handleUserName = this.userInfo.username
      let handleOpinion = data
      let handleType = type
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let task = {
        procInsId: this.procInst.id, procNodeId, procNodeName, nextUserId, nextUserName,
        handleUserId, handleUserName, handleOpinion, handleType, handleTime: now
      }
      let inst = { id: this.procInst.id, applyTime: now, currApproveId: this.userInfo.id, currApproveName: this.userInfo.username, processState: type }
      let map = { project, task, inst }
      map.type = 'approve'
      let msg = type == 2 ? "同意通过" : "拒绝通过"
      console.log('map', map);
      this.$confirm('确认' + msg + '该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log("getSearchResult", this.proCommitMap, this.activeName, this.proCommitMap[this.activeName]);
        let res = await projectApi.update(map)
        if (res.flag) {
          this.$message.success(res.data)
          await this.qryProject({ id: this.projectId })
        }
      })


    },
    async transOther(data) {//转出给其他人
      console.log("transOther", data)

      let procNodeId = this.lastNodeId||2
      let project = { id: this.project.id, state: 7 }
      let procNodeName = '项目转出'
      let nextUserId = data.id
      let nextUserName = data.name
      let handleUserId = this.userInfo.id
      let handleUserName = this.userInfo.username
      // let handleOpinion = "转给"+data.name
      let handleType = '4'
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let task = {
        procInsId: this.procInst.id, procNodeId, procNodeName, nextUserId, nextUserName,
        handleUserId, handleUserName, handleType, handleTime: now
      }
      let inst = { id: this.procInst.id, applyTime: now, userId: nextUserId, username: nextUserName, processState: '4' }
      let map = { project, task, inst }
      map.type = 'trans'

      console.log('map', map);
      this.$confirm('确认将该项目转给' + data.name + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log("transOther", this.proCommitMap, this.activeName, this.proCommitMap[this.activeName]);
        let res = await projectApi.update(map)
        if (res.flag) {
          this.$message.success(res.data)
          await this.qryProject({ id: this.projectId })
        }
      })


    },
    async transfer() {//转办
      this.title = '添加转办人'
      this.field = '转办人'
      this.$refs.selectUser.qryList()
      this.selectShow = true
      console.log(this.$refs.selectUser.title);

    },
    async commit() {//提交
      await this.validate()
      this.title = '添加处理人'
      this.field = '处理人'
      this.$refs.selectUser.qryList()
      this.selectShow = true

    },
    async getSearchResult(data) {
      this.selectShow = false
      if (this.field == '转办人') {
        await this.transOther(data)
      } else if (this.field == '处理人') {
        this.approver.id = data.id
        this.approver.name = data.name
        await this.save('commit')
      }
    },
    initInst(map) {//更新流程实例 再插入一新的流程节点
      let nextNodeMap = { create: 2, plan: 4, budget: 6, execute: 8, end: 10 }
      let node = this.procNodes.find(p => p.id == nextNodeMap[this.activeName])
      let time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let procInst = {
        "processState": "1",
        "userId": this.userInfo.id,
        "username": this.userInfo.username,
        "applyTime": time,
        "currNodeId": node.id,
        "currNodeName": node.nodeName,
        "currApproveId": this.approver.id,
        "currApproveName": this.approver.name,
      }
      let task = {
        "nextUserId": this.approver.id,
        "procNodeId": node.id,
        "procNodeName": node.nodeName,
        "nextUserName": this.approver.name,
        "handleUserId": this.userInfo.id,
        "handleUserName": this.userInfo.username,
        "handleTime": time,
        "handleType": "1"
      }
      if (Object.keys(this.procInst).length) {
        procInst.id = this.procInst.id
        task.procInsId = this.procInst.id
      /*   if (this.isAgainCommit) {//再次提交 不用选择审批人
          delete procInst.currApproveId
          delete procInst.currApproveName
          task.nextUserId = this.procInst.currApproveId
          task.nextUserName = this.procInst.currApproveName
        } else {//当前流程首次提交需要提交人
        } */
      } else {//第一次立项提交
        procInst.processKey = "project"
        procInst.processName = "项目流程"
        procInst.processId = 1

      }
      console.log('initInst', map, procInst, task);
      map.inst = procInst
      map.task = task
    },
    clickTab(tab, event) {
      console.log("clickTab", tab);
      this.clickList.push(this.activeName)
    },
    getTagType(status) {
      var json = { 1: "", 2: 'success', 3: 'danger', 4: 'danger' }
      return json[status];
    },
    /*
    不通场景下的保存与提交
     */
    /*create 立项阶段 
      保存  bs_project更新  bs_project_detail更新 
      第一次提交  bs_project更新  bs_project_detail更新 proc_instance插入 proc_task_instance插入
      再次提交  bs_project更新 bs_project_detail更新 proc_instance更新 proc_task_instance插入
     */
    async createSaveOrCommit(type) {
      if (type == 'commit') {
        await this.validate()
      }
      let param = { ...this.editForm }
      if (type == 'commit') param.state = 1
      for (const key in this.project) {
        if (this.project[key] == param[key]) {
          delete param[key]
        }
      }
      for (const key in this.detail) {
        if (this.detail[key] == param[key]) {
          delete param[key]
        }
      }
      let project = {}
      let detail = {}
      let projectKeys = Object.keys(this.project).filter(key => Object.keys(param).includes(key))
      let detailKeys = Object.keys(this.detail).filter(key => Object.keys(param).includes(key))
      if (type == 'save' && this.project.state == 0 && projectKeys.length == 0 && detailKeys.length == 0) {
        // this.$message.error("没有修改内容，无需保存")
        return {}
      }
      let map = {}
      if (projectKeys.length) {
        projectKeys.forEach(key => project[key] = param[key])
        project.id = this.project.id
        map.project = project
      }
      if (detailKeys.length) {
        detailKeys.forEach(key => detail[key] = param[key])
        detail.id = this.detail.id
        map.detail = detail
      }
      if (type == 'commit') {
        this.initInst(map)
      }
      return map
    },
    /*plan 实施方案上传阶段
      保存  bs_project_file更新
      提交  bs_project（状态更新）bs_project_file更新或插入 proc_instance更新 proc_task_instance插入 
     */
    async planSaveOrCommit(type) {
      let fileList = this.$refs.plan.fileList
      let map = {}
      map.fileList = fileList
      console.log('planSaveOrCommit', this.$refs.plan.fileList)
      if (type == 'save') {
        return map
      }
      map.project = { id: this.projectId, state: 2 }
      this.initInst(map)
      return map
    },
    /*  budget 预算阶段
      保存  bs_project_fee
      提交  bs_project（状态更新）bs_project_fee更新或插入 proc_instance更新 proc_task_instance插入
     */
    async budgetSaveOrCommit(type) {
      let feeList = this.$refs.budget.feeList
      let map = {}
      map.feeList = feeList.map(f => {
        let { itemNames, id, ...fee } = f
        fee.projectId = this.projectId
        return fee
      })
      if (map.feeList.length == 0) {
        //this.$message.error('至少添加一项费用！')
        return {}
      }
      console.log('budgetSaveOrCommit', this.editForm.remark, this.detail.remark)
      if (this.editForm.remark != this.detail.remark) {
        map.detail = { remark: this.detail.remark, id: this.detail.id }
      }
        map.projcetId= this.projectId
      if (type == 'save') {
        return map
      }
      map.project = { id: this.projectId, state: 3 }
      this.initInst(map)
      return map
    },
    /*  execute 执行阶段
      保存  bs_project_file更新 bs_project_member更新
      提交  bs_project（状态更新）bs_project_file更新或插入 bs_project_member更新或插入 proc_instance更新 proc_task_instance插入
     */
    async executeSaveOrCommit(type) {
      // let fileList = this.$refs.execute.fileList
      let masters = this.$refs.execute.masters
      let students = this.$refs.execute.students
      let map = {}
      // map.fileList = fileList
      map.memberList = [...masters, ...students]
     // console.log('executeSaveOrCommit', fileList)
      if (type == 'save') {
        return map
      }
      map.project = { id: this.projectId, state: 4 }
      this.initInst(map)
      return map
    },
    /*  end 结项评价阶段
      保存  bs_project_member更新
      提交  bs_project（状态更新） bs_project_member更新或插入 proc_instance更新 proc_task_instance插入
     */
    async endSaveOrCommit(type) {
      let masters = this.$refs.end.masters
      let memberList = this.$refs.end.memberList.map(m => {
        let find = masters.find(item => item.id == m.memberId)
        m.comment = find.comment
        m.fee = find.fee
        m.remark = find.remark
        return m
      })
      let map = {}
      map.memberList = memberList
      map.step = 'end'
      console.log('endSaveOrCommit', memberList)
      if (type == 'save') {
        return map
      }
      map.project = { id: this.projectId, state: 5 }
      this.initInst(map)
      //map.inst.currApproveId = ""
      //map.inst.currApproveName = ""
      return map
    },
    /**
     * 撤销
     *  bs_project 状态改成task倒数第二条的对应状态 
     * proc_instance 立项提交 删除流程实例 其他环节 update成task倒数第二条记录
     * proc_task_instance 最后一条删除
     */
    cancel() {
      let map = {}
      map.project = { id: this.projectId }
      let task = this.procTaskList[this.procTaskList.length - 1]
      map.task = task
      if (this.activeName == 'create') {
        map.inst = { "id": this.procInst.id }
        map.isCreateCommit = "1"
        map.project.state = 0
      } else {
        let task1 = this.procTaskList[this.procTaskList.length - 2]
        let stateMap = { '32': 11, '52': 12, '72': 13, '33': 21, '53': 22, '73': 23, '92': 14, '93': 24, '113': 25, '112': 6 }

        map.project.state = stateMap[task1.procNodeId + '' + task1.handleType]
        let procInst = {
          "id": this.procInst.id,
          "processState": task1.handleType,
          "userId": task1.nextUserId,
          "username": task1.nextUserName,
          "currNodeId": task1.procNodeId,
          "currNodeName": task1.procNodeName,
          "currApproveId": task1.handleUserId,
          "currApproveName": task1.handleUserName,
        }
        map.inst = procInst
      }
      console.log("cancel", map);
      this.$confirm('确认撤销本次提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        let res = await projectApi.cancel(map)
        if (res.flag) {
          this.$message.success(res.data)
          await this.qryProject({ id: this.projectId })
        }
      })
    }


  },
  computed: {
    commitFlag() {//提交按钮是否显示
      try {
        //已保存 && 创建人为当前用户
        if (this.project.state == '0' && this.project.empId == this.userInfo.id) return true
        // 下一个节点操作为creater && 当前点击的tab为activeList最后一个 && 当前节点下一个处理人为当前用户
        let task = this.procTaskList[this.procTaskList.length - 1]
        let node = this.procNodes.find(p => p.id == this.lastNodeId)
        console.log("commitFlag", task, node);
        if (node.handler == 'creater' && this.activeName == this.activeList[this.activeList.length - 1] && task.nextUserId == this.userInfo.id) {
          return true
        }
      } catch (error) {
        console.log(error);
      }
      return false
    },
    cancelFlag() {//撤销  项目状态为已提交
      try {

        // 下一个节点操作为approver && 当前点击的tab为activeList最后一个 && 当前节点下一个处理人为当前用户
        let task = this.procTaskList[this.procTaskList.length - 1]
        let node = this.procNodes.find(p => p.id == this.lastNodeId)
        if(task.nextUserId == this.userInfo.id) return false
        console.log("cancelFlag", task, node);
        if (node.handler == 'approver' && this.activeName == this.activeList[this.activeList.length - 1]
         && task.handleUserId == this.userInfo.id && task.handleType == 1) {
          return true
        }
      } catch (error) {
        console.log(error);
      }
      return false
    },
    approveFlag() {//审批按钮是否显示
      // 下一个节点操作为approver && 当前点击的tab为activeList最后一个 &&( 当前节点下一个处理人为当前用户)
      try {
        let task = this.procTaskList[this.procTaskList.length - 1]
        let node = this.procNodes.find(p => p.id == this.lastNodeId)
        console.log("approveFlag", task, node);
        if (node.handler == 'approver' && this.activeName == this.activeList[this.activeList.length - 1]
          && task.nextUserId == this.userInfo.id) {
          return true
        }
      } catch (error) {
        console.log(error);
      }
      return false
    },
    isAgainCommit() {//是否是审批不通过再次提交
      try {
        return this.project.procInstId && this.procTaskList[this.procTaskList.length - 1].handleType == 3

      } catch (error) {
        return false
      }
    }

  },
  watch: {

  },
  components: {
    'detail-info': detailInfo,
    'base-info': baseInfo,
    'approve-info': approveInfo,
    'plan-upload': planUpload,
    'budget': budget,
    'select-user': selectUser,
    'execute': execute,
    'end-project': endProject,
  },

  beforeDestroy() {

    clearInterval(this.timer);

  }
}
</script>

<style lang="less"  >
.project-detail {
  .main-box {
    display: flex;
    flex-shrink: 0;
  }
  .project-name {
    background: #fff;
    border-radius: 10px;
    font-size: 16px;
    padding: 10px 20px;
    margin-bottom: 20px;
    > i {
      font-size: 20px;
      color: #346aff;
      font-weight: 400;
    }
  }
  .body {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    margin-top: 0px;
    background: #fff;
    .commit-box {
      // text-align: center;
      padding-bottom: 20px;
      display: flex;
      justify-content: center;
      .commit-btn {
        font-size: 16px;
        width: 200px;
        color: #fff;
        background: #3b63ff;
        border-radius: 10px;
        border: none;
      }
      .transfer-btn {
        font-size: 16px;
        width: 200px;
        color: #3b63ff;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #3b63ff;
      }
      .save-btn {
        border-radius: 10px;
        margin-left: 40px;
        font-size: 16px;
        width: 200px;
        color: #fff;
        background: #a6aab8;
        border: none;
      }
    }
  }
  .el-tabs {
    margin-top: 20px;
    background: #fff;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    flex-direction: column;
    .el-tabs__header {
      border-bottom: none;
      margin-bottom: 0;
      background: #f5f5fc;
      .el-tabs__nav-wrap {
        margin-bottom: 0;
        overflow: visible;
        .el-tabs__nav-scroll {
          overflow: visible;
        }
      }
      .el-tabs__nav {
        border: none;
        .el-tabs__item {
          border: none;
          background: #2e57e6;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
          color: #fff;
          height: 32px;
          line-height: 32px;
        }
        .el-tabs__item + .el-tabs__item {
          margin-left: 10px;
        }

        .el-tabs__item.is-disabled {
          background: #999999;
          cursor: not-allowed;
        }
        .el-tabs__item.is-active {
          background: #e84f57;
          position: relative;
          &::before {
            content: "";
            width: 0px;
            height: 0px;
            border-width: 6px 6px;
            border-color: #e84f57 transparent transparent;
            border-style: solid;
            display: inline-block;
            position: absolute;
            bottom: -12px;
            left: 50%;
            margin-left: -6px;
            z-index: 20;
          }
        }
        .el-tabs__item.actived {
          background: #2e57e6;
        }
      }
    }
    .el-tabs__content {
    }
  }
  .proc-box {
    margin-left: 20px;
    width: 240px;
    min-height: 400px;
    background: #fff;
    border-radius: 10px;
    flex-shrink: 0;
    padding: 0 10px;
    box-shadow: none !important;
    .el-card__header {
      font-size: 16px;
      padding-top: 10px;
      span {
        display: block;
        padding-left: 20px;
        position: relative;
        &::before {
          position: absolute;
          content: "";
          width: 4px;
          height: 20px;
          background: #346aff;
          opacity: 1;
          display: block;
          left: 0px;
          top: 1px;
        }
      }
    }
    .el-card__body {
      padding: 20px 0;
      .proc-list {
        .proc-item {
          font-size: 12px;
          display: flex;
          .proc-name {
            color: #3c4353;
            margin-right: 20px;
            margin-top: -5px;
            width: 48px;
          }
          .proc-info {
            display: flex;
            flex-direction: column;
            padding-left: 20px;
            min-height: 100px;
            position: relative;
            border-left: 1px solid #cbddfe;
            padding-bottom: 10px;
            &::before {
              background: #0059ec;
              content: "";
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 10px;
              position: absolute;
              left: -5px;
            }
            .el-tag {
              align-self: baseline;
              border-radius: 20px;
              margin-bottom: 10px;
              margin-top: -5px;
            }
            .time-info {
              color: #ababab;
            }
            .handler {
              color: #525252;
              margin-top: 10px;
            }
            .opinion {
              color: #525252;
              margin-top: 10px;
              margin-bottom: 15px;
            }
          }
          &:last-child {
            .proc-info {
              border-left: none;
            }
          }
        }
      }
    }
  }
}
</style>
